import { parseDecimal, type Qty, toQty } from "@bt/parts-core";

// Qty, MILLI, toQty, fromQty and parseDecimal are shared with the collector (@bt/parts-core).

/**
 * Parses user input in either decimal convention ("5,5", "5.5", "1.250,5", "1,250.5").
 * Returns milli-units, or null when the text is not a number.
 */
export function parseQty(input: string): Qty | null {
  const amount = parseDecimal(input);
  return amount === null ? null : toQty(amount);
}

export function sumQty(values: Iterable<Qty>): Qty {
  let total = 0;
  for (const value of values) total += value;
  return total;
}
